(function () {
  var roots = document.querySelectorAll('.rb');
  if (!roots.length) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('rb-js');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = el.getAttribute('data-rb-delay');
      if (delay) el.style.transitionDelay = delay + 'ms';
      el.classList.add('is-in');
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

  document.querySelectorAll('.rb-reveal').forEach(function (el) { io.observe(el); });
})();

(function () {
  var raiz = document.querySelector('[data-rbp-carrossel]');
  if (!raiz) return;
  var trilho = raiz.querySelector('[data-rbp-trilho]');
  var pontos = raiz.querySelector('[data-rbp-pontos]');
  var ant = raiz.querySelector('[data-rbp-ant]');
  var prox = raiz.querySelector('[data-rbp-prox]');
  var slides = [].slice.call(trilho.children);
  if (slides.length < 2) { raiz.querySelector('.rbp-carrossel__topo').hidden = true; }

  slides.forEach(function (s, i) {
    var b = document.createElement('button');
    b.className = 'rbp-ponto';
    b.type = 'button';
    b.setAttribute('aria-label', 'Ir para o destaque ' + (i + 1));
    b.addEventListener('click', function () { irPara(i); });
    pontos.appendChild(b);
  });

  function atual() {
    var rt = trilho.getBoundingClientRect();
    var pad = parseFloat(getComputedStyle(trilho).paddingInlineStart) || 0;
    var borda = rt.left + pad;
    var melhor = 0, dist = Infinity;
    slides.forEach(function (s, i) {
      var d = Math.abs(s.getBoundingClientRect().left - borda);
      if (d < dist) { dist = d; melhor = i; }
    });
    return melhor;
  }
  function irPara(i) {
    var s = slides[Math.max(0, Math.min(slides.length - 1, i))];
    var rt = trilho.getBoundingClientRect();
    var rs = s.getBoundingClientRect();
    var pad = parseFloat(getComputedStyle(trilho).paddingInlineStart) || 0;
    var alvo = trilho.scrollLeft + (rs.left - rt.left) - pad;
    trilho.scrollTo({ left: Math.max(0, alvo), behavior: 'smooth' });
  }
  function sincroniza() {
    var i = atual();
    [].slice.call(pontos.children).forEach(function (p, k) {
      p.setAttribute('aria-current', k === i ? 'true' : 'false');
    });
    if (ant) ant.disabled = trilho.scrollLeft <= 2;
    if (prox) prox.disabled = trilho.scrollLeft + trilho.clientWidth >= trilho.scrollWidth - 2;
  }
  if (ant) ant.addEventListener('click', function () { irPara(atual() - 1); });
  if (prox) prox.addEventListener('click', function () { irPara(atual() + 1); });
  trilho.addEventListener('scroll', function () {
    window.clearTimeout(trilho._t);
    trilho._t = window.setTimeout(sincroniza, 80);
  });
  window.addEventListener('resize', sincroniza);
  window.addEventListener('load', sincroniza);
  if ('ResizeObserver' in window) { new ResizeObserver(sincroniza).observe(trilho); }
  slides.forEach(function (s) {
    var im = s.querySelector('img');
    if (im && !im.complete) { im.addEventListener('load', sincroniza, { once: true }); }
  });
  sincroniza();
})();
